import {Select} from '@/components/Form/index.mjs'
import useBaselines from './useBaselines.mjs'

export default function SelectBaseline({
    isDesc,
    pblProgress,
    pblStsCodes,
    pblType,
    prjId,
    prjPatternId,
    ...props
}) {
    const {data: options} = useBaselines({
        isDesc,
        pblProgress,
        pblStsCodes,
        pblType,
        prjId,
        prjPatternId,
    })

    const getOptionKey = e => e.pkid
    const getOptionLabel = e => `[${e.sVer}]${e.pblName}`

    return (
        <Select
            getOptionKey={getOptionKey}
            getOptionLabel={getOptionLabel}
            keyAsValue={false}
            options={options}
            {...props}
        />
    )
}
